import { render } from "./DialogueHighCharts.vue?vue&type=template&id=081df73d&scoped=true&ts=true"
import script from "./DialogueHighCharts.vue?vue&type=script&lang=ts"
export * from "./DialogueHighCharts.vue?vue&type=script&lang=ts"

import "./DialogueHighCharts.vue?vue&type=style&index=0&id=081df73d&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081df73d"]])

export default __exports__